assign_manage_users_search_submit = () ->
  $('#manage_users_search').submit(() ->
    window.find_users_request.abort() if window.find_users_request
    window.find_users_request = $.get(this.action, $(this).serialize(), null, 'script')
    false
  )

assign_manage_users_search_key_up = () ->
  $('#manage_users_search input').keyup( () ->
    window.find_users_request.abort() if window.find_users_request
    window.find_users_request = $.get($('#manage_users_search').attr('action'), $('#manage_users_search').serialize(), null, 'script')
    false
  )

assign_manage_users_click_actions = () ->
  window.assign_clickable_row_actions()
  links = $('#users th a, #users .pagination a, #manage_users_search a')
  links.off('click')
  links.on('click', (e) ->
    $.getScript(this.href)
    false
  )

# Expose functions globally so they can be called from Rails .js.erb views
window.assign_manage_users_search_submit = assign_manage_users_search_submit
window.assign_manage_users_search_key_up = assign_manage_users_search_key_up
window.assign_manage_users_click_actions = assign_manage_users_click_actions

$ ->
  if $("body.manage_users").length > 0
    assign_manage_users_search_submit()
    assign_manage_users_search_key_up()
    assign_manage_users_click_actions()
    unless $("#user_name").length == 0 || $("#user_name").val().trim() == ""
      window.find_users_request.abort() if window.find_users_request
      window.find_users_request = $.get($('#manage_users_search').attr('action'), $('#manage_users_search').serialize(), null, 'script')

